import React from "react"
import { SearchBarProps } from "./types"
import styles from "./PullDown.module.css"

export const SearchBar = ({
    searchQuery,
    onSearchChange,
    onClear,
    placeholder = "検索する",
}: SearchBarProps) => {
    return (
        <React.Fragment>
            <div className={styles.searchInputWrapper}>
                <input
                    type="text"
                    value={searchQuery}
                    onChange={e => onSearchChange(e.target.value)}
                    placeholder={placeholder}
                    className={styles.searchInput}
                />
            </div>
            {searchQuery && <button onClick={onClear}>キャンセル</button>}
        </React.Fragment>
    )
}
